const datepickerOptions = {
    dateFormat: 'dd.mm.yy',
    showButtonPanel: true
}

const autocompleteOptions = {
    open: function () {
        $(this).autocomplete('widget').addClass('ui-autocomplete-dropdown')
        const width = $(this).outerWidth()
        $('.ui-autocomplete-dropdown').css('width', width + 'px')
    }
}

const tooltipOptions = {
    html: true,
    boundary: 'viewport'
}

const determineElements = (content, selector) => {
    return typeof content !== 'undefined' ? $(content).find(selector) : $('body').find(selector)
}

const reinitializeDatepicker = (content, options) => {

    const elements = determineElements(content,
        'input[data-datepicker="true"]:not(.no-ready):not(.disable-vendor), input.datepicker:not(.no-ready):not(.disable-vendor)'
    )

    if (elements.length === 0) return

    for (const inputDatePicker of elements) {

        $(inputDatePicker)
            .datepicker({
                ...datepickerOptions,
                ...options
            })
            .on(
                'click',
                function () {
                    // CSS fix for datepicker inside a scrollable bootstrap 4 modal
                    $("#ui-datepicker-div").css('position', 'absolute');
                    $("#ui-datepicker-div").css('top', '2.25rem')
                    $("#ui-datepicker-div").css('left', 0)
                    $("#ui-datepicker-div").appendTo($(inputDatePicker).parent())
                }
            )

    }

}

const reinitializeAutocomplete = (content, options) => {

    const elements = determineElements(content,
        'input[class*="ui-autocomplete"]:not(.no-ready):not(.disable-vendor)'
    )

    if (elements.length === 0) return

    for (const inputAutocomplete of elements) {

        $(inputAutocomplete)
            .autocomplete({
                ...autocompleteOptions,
                ...options
            })
    }
}

const reinitializeCkeditor5 = (content, options) => {

    const elements = determineElements(content, 'textarea.ckeditor5:not(.no-ready):not(.disable-vendor)')

    if (elements.length === 0) return

    $(elements).each(function () {
        $(this).trigger('ckeditor5-reinitialize')
    })

}

const reinitializeTooltip = (content, options) => {

    const elements = determineElements(content, '[data-toggle="tooltip"]:not(.no-ready):not(.disable-vendor)')

    if (elements.length === 0) return

    elements.tooltip({
        ...tooltipOptions,
        ...options
    })

}

const reinitializeCollapsible = (content, options) => {

    const selectorElements= '[data-toggle="collapse"]:not(.no-ready):not(.disable-vendor)'

    const elements = determineElements(content,
        `${selectorElements} .eii--fa6-solid--sort-down,` +
        ` ${selectorElements} .eii--fa6-solid--sort-up,` +
        ` ${selectorElements} .eii--fa6-solid--chevron-right,` +
        ` ${selectorElements} .eii--fa6-solid--chevron-up,`+
        ` ${selectorElements} .eii--fa6-solid--square-plus,` +
        ` ${selectorElements} .eii--fa6-solid--square-minus`
    )

    if (elements.length === 0) return

    $(elements).parent().each(function () {
        $(this).off().on('click',function (event) {
            const icon = $(this).find('i')

            if (icon.length === 0) return

            if (icon.hasClass('eii--fa6-solid--sort-down')) {
                icon.removeClass('eii--fa6-solid--sort-down').addClass('eii--fa6-solid--sort-up');
                return;
            }

            if (icon.hasClass('eii--fa6-solid--sort-up')) {
                icon.removeClass('eii--fa6-solid--sort-up').addClass('eii--fa6-solid--sort-down');
                return;
            }

            if (icon.hasClass('eii--fa6-solid--chevron-right')) {
                icon.removeClass('eii--fa6-solid--chevron-right').addClass('eii--fa6-solid--chevron-up');
                return;
            }

            if (icon.hasClass('eii--fa6-solid--chevron-up')) {
                icon.removeClass('eii--fa6-solid--chevron-up').addClass('eii--fa6-solid--chevron-right');
                return;
            }

            if (icon.hasClass('eii--fa6-solid--square-plus')) {
                icon.removeClass('eii--fa6-solid--square-plus').addClass('eii--fa6-solid--square-minus');
                return;
            }

            if (icon.hasClass('eii--fa6-solid--square-minus')) {
                icon.removeClass('eii--fa6-solid--square-minus').addClass('eii--fa6-solid--square-plus');
                return;
            }
        });
    })
}

const reinitialize = (content, options) => {

    reinitializeDatepicker(content, options?.datepicker ?? {})
    reinitializeAutocomplete(content, options?.autocomplete ?? {})
    reinitializeCkeditor5(content, options?.ckeditor5 ?? {})
    reinitializeTooltip(content, options?.tooltip ?? {})
    reinitializeCollapsible(content, options?.collapsible ?? {})

}

export {
    reinitialize,
    reinitializeDatepicker,
    reinitializeAutocomplete,
    reinitializeCkeditor5,
    reinitializeTooltip,
    reinitializeCollapsible
}
